import axios from "axios";
import { useState } from "react";
import { Col, Row, Spinner } from "react-bootstrap";
import { SubmitHandler, useForm } from "react-hook-form";
import { IoMdArrowBack } from "react-icons/io";
import { Link, useNavigate } from "react-router-dom";
import AlertModal from "../../../components/alertModal/alertModal";
import AuthScreenLayout from "../../../components/authScreenLayout/AuthScreenLayout";
import TextInfo from "../../../components/textInfo/TextInfo";
import TextInput, { EInputMode } from "../../../components/textInput/TextInput";
import Title from "../../../components/title/Title";
import { FORGET_PASSWORD_OTP_SEND_Url } from "../../../const/URL";
import { Divider, Button, Box } from "@mui/material";
import fogotPsw from "../../../assets/images/forgot-password.png";

interface IForgetPasswordInput {
  email: string;
}

const ForgetPassword = () => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<IForgetPasswordInput>();
  const [isLoading, setIsLoading] = useState(false);
  const [show, setShow] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const navigate = useNavigate();

  const handleClose = () => {
    setShow(false);
    setErrorMessage("");
  };

  const onSubmit: SubmitHandler<IForgetPasswordInput> = (data) => {
    if (!data.email) {
      return;
    }

    setIsLoading(true);
    axios
      .post(FORGET_PASSWORD_OTP_SEND_Url + "?username=" + data.email)
      .then((res) => {
        setIsLoading(false);

        let errorMessage = "Something went wrong! Please try again.";

        if (res.status === 200 && res.data.isSuccess === true) {
          navigate("/verifyOtp", {
            state: { username: data.email, flow: "FORGET_PASSWORD" },
          });
          return;
        } else if (res.status === 200 && res.data.isSuccess === false) {
          setShow(true);
          errorMessage = res.data.errorMessage;
        }
        setErrorMessage(errorMessage);
      })
      .catch(() => {
        setIsLoading(false);
        setShow(true);
        let errorMessage = "Something went wrong! Please try again.";
        setErrorMessage(errorMessage);
      });
  };

  return (
    <>
      <AuthScreenLayout>
        <Row>
          <Col className="mt-2 mb-1 poppins-semibold ">
            <Link to={"/"}>
              <IoMdArrowBack color="black" />{" "}
              <span className="text-black">Login</span>
            </Link>
          </Col>
        </Row>
        <Box
          component="img"
          src={fogotPsw}
          alt="Logo"
          sx={{
            width: "250px",
            height: "auto",
            marginTop: 4,
            mb: 4,
          }}
        />
        <Row>
          <Col>
            <Title className="mb-4 poppins-bold" color="black" fontSize={26}>
              Forgot Password
            </Title>
          </Col>
        </Row>
        <Row>
          <Col className="mb-4">
            <TextInfo fontSize={16} className="poppins-regular" color="gray">
              Enter your registered email address and we will send an OTP to
              your e-mail/mobile to reset your password
            </TextInfo>
          </Col>
        </Row>
        <form onSubmit={handleSubmit(onSubmit)}>
          <Row>
            <Col>
              <TextInput
                textAlign="left"
                required
                name="username"
                mode={EInputMode.light}
                color="gray"
                placeholder="✉️   Email"
                className="poppins-regular"
                useFormRegister={{
                  ...register("email", {
                    required: true,
                    pattern:
                      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                  }),
                }}
                errors={[
                  {
                    isShow: errors.email?.type === "required",
                    message: "Email is required",
                  },
                  {
                    isShow: errors.email?.type === "pattern",
                    message: "Email is invalid",
                  },
                ]}
              />
            </Col>
          </Row>
          <Divider
            sx={{
              marginTop: 5,
              marginBottom: 1,
              backgroundColor: " rgb(31, 75, 155)",
              alignItems: "center",
              display: "flex",
              justifyContent: "center",
            }}
          />
          <Row>
            <Col className="mt-3 mt-md-5 mb-4 text-center">
              {isLoading ? (
                <Spinner animation="border" variant="success" />
              ) : (
                // <Button
                //   type="submit"
                //   style={{ backgroundColor: "#51B848", borderColor: "#51B848" }}
                //   className="w-100"
                // >
                //   Submit
                // </Button>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "flex-end",
                    height: "100%",
                  }}
                >
                  <Button
                    type="submit"
                    sx={{
                      background: "#51B848",
                      borderRadius: 30,
                      color: "white",
                      width: "300px",
                      height: "50px",
                      textAlign: "center",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      ":hover": {
                        background: "#5C725A",
                      },
                    }}
                  >
                    Submit
                  </Button>
                </Box>
              )}
            </Col>
          </Row>
        </form>
      </AuthScreenLayout>
      <AlertModal
        show={show}
        variant="error"
        buttons={[
          {
            text: "OK",
            onClick: handleClose,
            variant: "success",
          },
        ]}
      >
        {errorMessage}
      </AlertModal>
    </>
  );
};

export default ForgetPassword;
